import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/',
      component: () => import('./layouts/base/BaseLayout.vue'),
      redirect: '/home',
      children: [
        {
          path: "/home",
          component: () => import('./views/home'),
        },
        {
          path: "/selftrain",
          component: () => import('./views/selftrain'),
        },
        {
          path: "/account",
          component: () => import('./views/account'),
        },
        {
          path: "/netdisk",
          component: () => import('./views/netdisk'),
        },
        ,
        {
          path: "/netdisk",
          component: () => import('./views/netdisk'),
        },
        {
          path: "/schedule",
          component: () => import('./views/schedule'),
        },
      ]

    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  //debugger
  // 从localStorage中获取用户ID,特别注意的是vuex的状态信息会在页面刷新的时候重置，所以用户信息是存在localStorage中
  let userId = localStorage.getItem('id')
  if (to.path === '/login') {
    next();
  } else {
    // 如果用户id有,则说明用户已经登录,路由放行
    if (userId) {
      next();
    } 
    // 如果用户id没有,说明用户没有登录,需要跳转到登录页面让用户去登录
    else {
      next({ path: "/login" });
    }
  }
})


export default router;